import { SettingConst } from '@faire/web-api--source/types';

/**
 * Change copy from shop to buy.
 * https://www.notion.so/faire/Shop-Buy-1e42efb5c25a80818b4ffd6a021a9777
 */
export const SHOP_TO_BUY_250508 = 'SHOP_TO_BUY_250508' as SettingConst<
  'SHOP_TO_BUY_250508',
  boolean,
  'RETAILER'
>;
